module.exports = __webpack_public_path__ + "img/device02.5684314f.png";